import { call, put, select } from 'redux-saga/effects';
import { actions } from '../reducer';
import { chatsApi } from '../../../../shared/api/axios/chat';
import { RT } from '../../../../shared/types';
import { selectChatsEntityId } from '../selectors';
import { teamsModel } from '../../../teams';
import { createNotification } from '../../../snackbar';
import { snackbarModel } from '../../../snackbar';

export function* updateChatSettings(
  action: ReturnType<typeof actions.updateChatSettings>
) {
  try {
    const chatsEntityId: RT<typeof selectChatsEntityId> = yield select(
      selectChatsEntityId
    );

    const currentTeam: RT<
      typeof teamsModel.selectors.selectCurrentTeamWithError
    > = yield select(teamsModel.selectors.selectCurrentTeamWithError);

    const updatedSettings: RT<typeof chatsApi.updateChatSettings> = yield call(
      chatsApi.updateChatSettings,
      {
        entityId: chatsEntityId,
        teamId: currentTeam.id,
        settings: action.payload,
      }
    );
    yield put(actions.setChatSettings(updatedSettings));
  } catch (error) {
    yield put(
      snackbarModel.actions.addNotificationAction(
        createNotification('error', 'Failed to update chat settings')
      )
    );
  }
}
